export default function HeroSection() {
  return (
    <section id="about" className="relative overflow-hidden">
      {/* Banner Image */}
      <div className="max-w-6xl mx-auto px-6 md:px-12 pt-10">
        <img
          alt="Blue wildflower meadow landscape"
          className="w-full h-auto object-contain rounded-lg hover:scale-[1.03] hover:-translate-y-[4px] hover:shadow-lg transition-all duration-300 ease-out"
          src="https://storage.readdy-site.link/project_files/185c4543-d0dc-49d0-8dbb-59fc7deb7f59/4d5c3037-c9af-47f6-bdf8-dc98d98f2d0c_Banner-2-.png?v=9601c2c8a8e1bc8c8627c0876333b127"
        />
      </div>

      {/* Hero Content */}
      <div className="relative pt-12 pb-16">
        <div className="absolute top-10 right-[-8%] w-[480px] h-[480px] rounded-full bg-background-200/60 pointer-events-none" />
        <div className="absolute bottom-10 left-[-4%] w-[280px] h-[280px] rounded-full bg-accent-200/20 pointer-events-none" />

        <div className="max-w-6xl mx-auto px-6 md:px-12 w-full">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            {/* Left Content */}
            <div className="relative z-10">
              <p className="font-body text-xs font-semibold uppercase tracking-widest text-accent-600 mb-3">
                Federica Tedeschi · ICF Certified Coach
              </p>
              <h1 className="font-heading text-3xl md:text-4xl font-bold text-primary-800 leading-tight mb-4">
                Energy-Safe Coaching for Chronic Pain, Fatigue, Neurodivergence &amp; Fluctuating Energy
              </h1>
              <p className="font-heading text-base md:text-lg font-semibold text-accent-600 mb-2">
                The Energy-Safe Method by Healing &amp; Breakthrough
              </p>
              <p className="font-body text-base text-primary-700 italic mb-5 max-w-lg">
                A nervous-system-informed approach that works with your energy — not against it.
              </p>

              <div className="space-y-3 text-foreground-600 text-sm leading-relaxed mb-6 max-w-lg">
                <p>
                  <strong className="text-primary-700">The Energy-Safe Method is</strong> a coaching framework for people living with chronic pain, chronic fatigue, ADHD/Autism sensory drain, or the daily reality of responsibilities that outpace their biological capacity. Together, we break the <strong className="text-primary-700">Boom and Bust cycle</strong> and rebuild your energy and your life using <strong className="text-primary-700">Energy-Safe Motions</strong> — small, nervous-system-first steps that respect your limits instead of pushing past them, powered by <strong className="text-primary-700">NLP (Neuro-Linguistic Programming)</strong> to create lasting, sustainable change.
                </p>
              </div>

              <div className="mb-8 max-w-lg rounded-lg px-5 py-3 border-l-4 border-accent-400 bg-accent-50/50">
                <p className="text-sm font-semibold italic text-primary-700">
                  The Energy-Safe Truth: Rest isn&apos;t a retreat, it&apos;s a strategic reload.
                </p>
              </div>

              <div className="flex flex-col sm:flex-row gap-4">
                <a
                  href="https://calendly.com/federicatedeschi3/new-meeting"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="bg-primary-500 text-background-50 px-8 py-3.5 rounded-lg font-medium text-center hover:bg-primary-600 hover:scale-[1.05] hover:-translate-y-[3px] hover:shadow-lg transition-all duration-300 ease-out shadow-soft whitespace-nowrap cursor-pointer text-sm"
                >
                  Book a Free Conversation
                </a>
                <a
                  href="#services"
                  onClick={(e) => {
                    e.preventDefault();
                    document.querySelector("#services")?.scrollIntoView({ behavior: "smooth" });
                  }}
                  className="border-2 border-primary-500 text-primary-700 px-8 py-3.5 rounded-lg font-medium text-center hover:bg-primary-500 hover:text-background-50 hover:scale-[1.05] hover:-translate-y-[3px] hover:shadow-lg transition-all duration-300 ease-out whitespace-nowrap cursor-pointer text-sm"
                >
                  Learn More
                </a>
              </div>
            </div>

            {/* Right - Logo */}
            <div className="relative z-10 flex flex-col items-center justify-center pt-4">
              <div className="w-80 h-80 flex items-center justify-center">
                <img
                  alt="Healing & Breakthrough Coaching logo"
                  className="w-80 h-80 object-contain hover:scale-[1.06] hover:-translate-y-[4px] hover:shadow-lg transition-all duration-300 ease-out"
                  src="https://storage.readdy-site.link/project_files/185c4543-d0dc-49d0-8dbb-59fc7deb7f59/c0cd9c52-4c80-4827-8208-f750b5440eb5_Logo-.png?v=908c6ba8c809d066ed81cd723f530f12"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}